
// Add to Cart button effect
function setAddToCartEffect(toggle) {
    var btn = $('#AddToCart');
    if (!toggle) {
      $('span#AddToCart').html( "Add to Cart" );
      btn.removeAttr('data-loading').removeAttr('disabled');
    } else {
      btn.attr('data-loading', '').attr('disabled', '');
    }
  }

 
// Create our number formatter.
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  // the default value for minimumFractionDigits depends on the currency
  // and is usually already 2
});


// Toggle the purchasing funnel pane on the Product Detail page
$('.funnel__toggler').click(function(){
  $(this).next('.funnel__pane').toggleClass('open');    console.log(123);
});

// Toggle the purchasing funnel additional options "Not a professional" pane on the Product Detail page
$('.add-opts__toggler').click(function(){
  $(this).next('.add-opts__pane').toggleClass('open');
  return false;
});


jQuery('body').on('afterCartLoad.ajaxCart', function(evt, cart) {
        // Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM

});

jQuery('body').on('beforeAddItem.ajaxCart', function(evt, cart) {
  // Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
  // cart is the result of /GET cart.js (https://docs.shopify.com/support/your-website/themes/can-i-use-ajax-api#get-cart)

  // Open Timber's drawer when cart is ready
  ///timber.RightDrawer.open();

  setAddToCartEffect(true);

 
                         
 
});

jQuery('body').on('afterCartLoad.ajaxCart', function(evt, cart) {
  // Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
  // cart is the result of /GET cart.js (https://docs.shopify.com/support/your-website/themes/can-i-use-ajax-api#get-cart)

  // Open Timber's drawer when cart is ready
  ///timber.RightDrawer.open();
  
  setAddToCartEffect(false);
  
  jQuery('.cart-visible').show();
  $('span#CartCount').html( cart.item_count );
  $('span#CartCost').html( formatter.format(cart.total_price/100) );
  
 
});

if ( $('span#CartCount').html() > 0 )
 jQuery('.cart-visible').show();